import { LoanApplicationDocument } from '@axo/shared/data-access/types';
import styles from './DocumentItemView.module.css';
import React, { useState } from 'react';
import {
  useLoanApplicationDocument,
  usePatchLoanApplicationDocument,
} from '@axo/shared/data-access/hooks';
import { IconButton } from '../../../IconButton';
import { formatDatetime } from '../../../../utils/formatDate';
import { SmallTag } from '../../../SmallTag';
import { InputGroup } from '@blueprintjs/core';

interface DocumentItemViewProps {
  applicationID: string;
  document: LoanApplicationDocument;
}

export const DocumentItemView: React.FC<DocumentItemViewProps> = ({
  applicationID,
  document,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [fileName, setFileName] = useState(document.Filename?.split('.')[0]);
  const getApplicationDocument = useLoanApplicationDocument(
    applicationID,
    document.ID,
  );

  const { mutateAsync: patchDocument } = usePatchLoanApplicationDocument();

  function handleDocumentDownload() {
    if (document.ID && getApplicationDocument.data) {
      window.open(getApplicationDocument.data, '_blank');
    }
  }

  function handleDocumentEdit() {
    setIsEditing(true);
  }

  async function handleSubmit() {
    await patchDocument({
      applicationID,
      documentID: document.ID,
      data: { Filename: `${fileName}.${document.Filename?.split('.')[1]}` },
    }).finally(() => {
      handleCancelEdit();
    });
  }

  function handleCancelEdit() {
    setFileName(document.Filename?.split('.')[0]);
    setIsEditing(false);
  }

  return (
    <div className={styles.itemViewContainer}>
      <div className={styles.container}>
        <div className={styles.mainInfo}>
          <div className={styles.nameDisplay}>
            {isEditing ? (
              <InputGroup
                type="text"
                name="Document name"
                onChange={(e) => setFileName(e.target.value)}
                value={fileName ?? ''}
                fill
              />
            ) : (
              <a
                aria-label="document download"
                onClick={handleDocumentDownload}
              >
                {document.Filename}
              </a>
            )}
          </div>
          <div className={styles.actions}>
            {isEditing ? (
              <>
                <IconButton
                  icon={'cross'}
                  onClick={handleCancelEdit}
                  size={20}
                  type="button"
                />
                <IconButton
                  icon={'tick'}
                  onClick={handleSubmit}
                  size={20}
                  type="button"
                />
              </>
            ) : (
              <>
                {/* <IconButton
                  icon={'eye-open'}
                  size={20}
                  type="button"
                  disabled
                /> */}
                <IconButton
                  icon={'annotation'}
                  onClick={handleDocumentEdit}
                  size={20}
                  type="button"
                />
              </>
            )}
          </div>
        </div>
        <div className={styles.bottomInfo}>
          <div className={styles.timestamp}>
            Uploaded: {formatDatetime(document.UpdatedAt as string)}
          </div>
          <div className={styles.updatedBy}>
            <SmallTag minimal>---{/* <UserName clientID={'-'} /> */}</SmallTag>
          </div>
        </div>
      </div>
    </div>
  );
};
